import { Trans, useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { UpdatedDate } from '@/components/LoanTerms/UpdatedDate';
import { LAST_UPDATED } from './constants';
import IconDue from './assets/icon_due.svg';
import IconGroup from './assets/icon_group.svg';
import IconList from './assets/icon_list.svg';
import { Features } from './components/features';
import { HowItWorks } from './components/how';
import s from './index.module.scss';

const ReportingModesPageV1 = () => {
  const { t } = useTranslation('reporting-modes');
  return (
    <div className={s.page}>
      <div className="container-inner">
        <h1 className="f-hero-h2">{t('page.financial_reporting_modes')}</h1>
        <p className="f-paragraph-regular" style={{ marginTop: '8px' }}>
          {t('page.choose_reporting_frequency')}
        </p>

        <div className={s.content}>
          <section className={s.why_block}>
            <h2 className="f-hero-h4">{t('page.why_collect_reporting')}</h2>
            <p className="f-body-regular">{t('page.reporting_explanation')}</p>
          </section>
          <section className={s.use}>
            <h3 className="f-hero-h5">{t('page.use_reporting_to')}</h3>
            <div className={s.use_table}>
              <div className={s.use_group}>
                <div className={s.use_group_icon}>
                  <img src={IconDue} alt="icon" width={24} height={24} />
                </div>
                <div className={s.use_group_content}>
                  <div className={classnames(s.use_group_title, 'f-body-accent')}>
                    {t('page.manage_credit_risk')}
                  </div>
                  <div className={classnames(s.use_group_desc, 'f-small-regular')}>
                    {t('page.bank_statements_explanation')}
                  </div>
                </div>
              </div>
              <div className={s.use_group}>
                <div className={s.use_group_icon}>
                  <img src={IconGroup} alt="icon" width={24} height={20} />
                </div>
                <div className={s.use_group_content}>
                  <div className={classnames(s.use_group_title, 'f-body-accent')}>
                    {t('page.meet_obligations')}
                  </div>
                  <div className={classnames(s.use_group_desc, 'f-small-regular')}>
                    {t('page.consistent_portfolio_data')}
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className={s.secure}>
            <div className={classnames(s.secure_note, 'f-paragraph-accent-s')}>
              {t('page.data_usage_note')}
            </div>
            <div className={classnames(s.secure_text, 'f-body-regular')}>
              <Trans
                ns="reporting-modes"
                i18nKey="page.reporting_frequency_choice"
                components={{
                  Span: <span className="f-body-accent" />,
                }}
              />
            </div>
          </section>
          <section>
            <div className={s.pick}>
              <div className={s.pick_left}>
                <div className="f-hero-h5">{t('page.pick_reporting_mode')}</div>
                <div className="f-body-regular">{t('page.reporting_modes_description')}</div>
              </div>
              <div>
                <div className="f-small-accent">{t('page.mode_defines')}</div>
                <ul className={classnames(s.pick_list, 'f-small-regular')}>
                  <li>
                    <img src={IconList} alt="icon" width={20} height={20} />
                    <span>{t('page.upload_frequency')}</span>
                  </li>
                  <li>
                    <img src={IconList} alt="icon" width={20} height={20} />
                    <span>{t('page.monthly_fee')}</span>
                  </li>
                  <li>
                    <img src={IconList} alt="icon" width={20} height={20} />
                    <span>{t('page.missing_deadline_consequence')}</span>
                  </li>
                </ul>
                <div className="f-small-regular">{t('page.mode_switching')}</div>
              </div>
            </div>
            <Features />
          </section>
          <HowItWorks />
        </div>
        <UpdatedDate className={s.update} date={LAST_UPDATED} />
      </div>
    </div>
  );
};

export default ReportingModesPageV1;
